import { render, staticRenderFns } from "./DeliveryBeforeChangeDlg.vue?vue&type=template&id=5d1d9853&scoped=true"
import script from "./DeliveryBeforeChangeDlg.vue?vue&type=script&lang=js"
export * from "./DeliveryBeforeChangeDlg.vue?vue&type=script&lang=js"
import style0 from "./DeliveryBeforeChangeDlg.vue?vue&type=style&index=0&id=5d1d9853&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d9853",
  null
  
)

export default component.exports